export default "__VITE_ASSET__Ca0n8fHj__"